// components/Progress.tsx
import React from "react";
import styled from "styled-components";

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value: number;
  max?: number;
}

const ProgressContainer = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 9999px;
  background-color: #D1D1D1;
  overflow: hidden;
  position: relative;
`;

const ProgressBar = styled.div<{ percentage: number }>`
  height: 100%;
  background-color: #18181B;
  width: ${({ percentage }) => percentage}%;
  transition: width 0.3s ease-in-out;
`;

export const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ value, max = 100, ...props }, ref) => {
    const percentage = Math.min(100, Math.max(0, (value / max) * 100));

    return (
      <ProgressContainer ref={ref} {...props}>
        <ProgressBar percentage={percentage} />
      </ProgressContainer>
    );
  }
);

Progress.displayName = "Progress";
